import Theme from "/components/Theme";
import WideCTA from "/components/organisms/common/WideCTA";
import People from "/components/organisms/common/People";
import AdaptiveCriticalImage from "/components/atoms/AdaptiveCriticalImage";
import FeaturedImage from "/components/organisms/bookingpage-demo/FeaturedImage";
import FeaturesShowCaseCards from "/components/organisms/bookingpage-demo/FeaturesShowCaseCards";

export async function getStaticProps(ctx) {
  const { locale } = ctx;
  let allData = {};

  // Fetch
  const headerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/header.json`
  );
  const footerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/footer.json`
  );
  const marketingResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/bookingpage/demos/marketing.json`
  );
  const contentResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/bookingpage/demos/content.json`
  );

  // Catch Error
  if (marketingResponse.status === 404 || contentResponse.status === 404) {
    return {
      notFound: true,
    };
  }

  // Convert
  allData.header = await headerResponse.json();
  allData.marketing = await marketingResponse.json();
  allData.content = await contentResponse.json();
  allData.footer = await footerResponse.json();

  // Wrap
  const header = {
    header: allData.header,
  };
  const footer = {
    footer: allData.footer,
  };

  // Combine all data
  const data = await {
    ...header,
    ...footer,
    ...allData.marketing,
    ...allData.content,
  };

  return {
    props: {
      data,
      fallback: false,
    },
  };
}

const Hero = ({ data }) => {
  return (
    <section className="container grid--default has-align-top hero--default lg:pb-6 md:pb-3">
      <article className="text-left lg:maxw-lg">
        <h1
          className="lg:maxw-xs lg:mt-3 md:mr-10 md:pr-2 text-xl"
          dangerouslySetInnerHTML={{ __html: data.title }}
        />

        <p
          className="lg:maxw-md lg:mb-1.5 md:mt-2.5 md:mb-2.5"
          dangerouslySetInnerHTML={{ __html: data.desc[0] }}
        />
        <p
          className="lg:maxw-md"
          dangerouslySetInnerHTML={{ __html: data.desc[1] }}
        />
      </article>
      <figure className="lg:ml-2 md:mt-4">
        <picture>
          <AdaptiveCriticalImage
            src={data.images.src}
            alt={data.images.alt}
            mobile={data.images.prefixes.mobile}
            dpi={data.images.prefixes.dpi}
            className="lg:w-auto img-fit"
            dimensions={[335, 285]}
          />
        </picture>
      </figure>
    </section>
  );
};

const HighlightCards = ({ data }) => {
  return (
    <section className="lg:pb-15 lg:pt-10 md:pt-10 md:pb-10 features">
      <article className="container lg:maxw-xl block--align-center lg:text-center md:text-left">
        <h2 className="text-xl md:text-mds">{data.title}</h2>
        <p className="mx-auto lg:mb-10 lg:text-center lg:maxw-xl">
          {data.desc}
        </p>
      </article>
      <FeaturesShowCaseCards data={data.featuresShowcaseCards} />
    </section>
  );
};

const Iframe = () => {
  return (
    <div id="popup">
      <button id="terms-close" className="popup-close">
        Close Demo
      </button>
      <iframe id="iframe"></iframe>
      <div className="overlay"></div>
    </div>
  );
};
export default function Index({ data, nonce }) {
  const { header, footer, seo, content } = data;
  return (
    <>
      <Theme
        header={header}
        footer={footer}
        seo={seo}
        nonce={nonce}
        className="page--home integration-listing-page land-pages cls-improvement--desktop booking-page-demo"
      >
        <Iframe />
        <Hero data={content.hero} />
        <section className="bg-light lg:pt-15 md:pt-10">
          {content.featuredImageSections.map((item, index) => {
            return (
              <FeaturedImage
                key={index}
                data={item}
                imageAlign={item.image.align}
              />
            );
          })}
        </section>
        <HighlightCards data={content.featuresShowcaseHeader} />
        <People />
        <WideCTA data={content.wideCTA} />
      </Theme>
    </>
  );
}
